import { ICategoryVote } from 'api/types/_campaign';
import { INews } from 'api/types/_news';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_INFO } from 'common/toast';
import DropdownCategoryVote from 'components/Common/DropdownCategoryVote';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { SCHEDULE_OPTIONS, SCHEDULE_VOTE_OPTIONS, SCHEDULE_WEEKLY_OPTIONS, SECTION_KEYWORD, STATUS_CAMPAIGN_OPTIONS } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import HighlightText from 'pages/News/Components/HighlightText';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../../components/Common/TableContainer";
import { allCategoryVote, getArticleVotesNormal } from "../../../store/thunks";
import ModalPreviewArticle from './ModalPreviewArticle';
export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'id';

registerLocale('en', en);
registerLocale('ko', ko);

const ArticleList = (activeTab?: any) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const isFirstLoadingPageRef = useRef<any>(true);

    const STATUS_CAMPAIGN_OPTIONS_LANG: any = STATUS_CAMPAIGN_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_OPTIONS_LANG: any = SCHEDULE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_VOTE_OPTIONS_LANG: any = SCHEDULE_VOTE_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const SCHEDULE_WEEKLY_OPTIONS_LANG: any = SCHEDULE_WEEKLY_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const [query, setQuery]: any = useQueryParams({
        time_request: withDefault(NumberParam, 0),
        page: withDefault(NumberParam, 1),
        limit: withDefault(NumberParam, 30),
        sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
        order_by: withDefault(StringParam, 'DESC'),
        section: withDefault(StringParam, `${SECTION_KEYWORD.CONTENT_VOTE_KEYWORD}`),
        vote_title: withDefault(StringParam, ''),
        title: withDefault(StringParam, ''),
        // start_date: withDefault(StringParam, START_DATE),
        // end_date: withDefault(StringParam, END_DATE),
        // campaign_id: withDefault(StringParam, ''),
        campaign_name: withDefault(StringParam, ''),
        cycle_type: withDefault(StringParam, ''),
        keyword: withDefault(StringParam, ''),
        dc_trend_category_id: withDefault(StringParam, ''),
        type_page_no_param: withDefault(StringParam, ''),
    });

    const [campaigns, setCampaigns] = useState<{ label: string, value: string, name: string }[]>([]);

    const [categoryVote, setCategoryVote] = useState<ICategoryVote[]>([]);

    const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

    const [categorySearch, setCategorySearch] = useState<Option | null>(null);

    const [voteTitleSearch, setVoteTitleSearch] = useState<string>(query?.vote_title || "");

    const [titleSearch, setTitleSearch] = useState<string>(query?.title || "");

    const [campaignNameSearch, setCampaignNameSearch] = useState<string>(query?.campaign_name || "");

    const [cycleTypeSearch, setCycleTypeSearch] = useState<Option | null>(SCHEDULE_VOTE_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.cycle_type)) || null);

    const [campaignSearch, setCampaignSearch] = useState<Option | null>(campaigns?.find((item) => String(item?.value) === String(query?.campaign_id)) || null);

    const [newsDetail, setNewsDetail] = useState<INews | null>(null);

    const [listNews, setListNews] = useState<{ list: INews[], total: number }>({ list: [], total: 0 });
    const [isListNewsLoading, setIsListNewsLoading] = useState<boolean>(false);

    const [idLoading, setIdLoading] = useState<string | number | null>(null);

    const [isShowPrompt, setIsShowPrompt] = useState<boolean>(false);
    const [promptShow, setPromptShow] = useState<string>('');

    const dispatch: any = useDispatch();

    const handleQueryData = async () => {
        setIsListNewsLoading((prev) => true);
        if (isFirstLoadingPageRef?.current === true && query?.page !== 1) {
            setQuery({
                ...query,
                type_page_no_param: '',
                page: 1
            });
            return;
        }
        isFirstLoadingPageRef.current = false;
        const res: any = await getArticleVotesNormal(query);
        setListNews((prev: any) => ({
            list: res?.data?.list || [],
            total: res?.data?.pagination?.total || 0,
        }));
        setIsListNewsLoading((prev) => false);

        if (!!newsDetail && query?.type_page_no_param) {
            if (query?.type_page_no_param === 'prev') {
                setNewsDetail((_prev) => res?.data?.list[res?.data?.list?.length - 1]);
                return;
            }
            if (query?.type_page_no_param === 'next') {
                setNewsDetail((_prev) => res?.data?.list[0]);
                return;
            }
        }
    };

    const handleLoadMore = () => {
        setQuery({
            ...query,
            page: query?.page + 1,
            type_page_no_param: 'next'
        });
    }

    const handleLoadPrev = () => {
        setQuery({
            ...query,
            page: query?.page - 1,
            type_page_no_param: 'prev'
        });
    }


    useEffect(() => {
        handleQueryData();
    }, [JSON.stringify(query)]);

    const searchData = () => {
        const queryNew = {
            ...query,
            keyword: keywordSearch || '',
            dc_trend_category_id: categorySearch?.value || '',
            vote_title: encodeURIComponent(voteTitleSearch || ''),
            title: titleSearch || '',
            campaign_name: campaignNameSearch || '',
            campaign_id: campaignSearch?.value || '',
            cycle_type: cycleTypeSearch?.value,
            page: 1,
            time_request: + new Date()
        };
        if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
            setListNews((prev: any) => ({
                list: [],
                total: 0,
            }));
        }
        setQuery(queryNew);
    };

    const resetData = () => {
        const queryNew = {
            keyword: '',
            dc_trend_category_id: '',
            vote_title: '',
            title: '',
            campaign_name: '',
            campaign_id: '',
            cycle_type: '',
            sort_by: TYPE_SELECT_DEFAULT,
            order_by: 'DESC',
            page: 1,
            time_request: + new Date(),
        };
        if (JSON.stringify(query) !== JSON.stringify(queryNew)) {
            setListNews((prev: any) => ({
                list: [],
                total: 0,
            }));
        }
        setQuery(queryNew, "push");
        setCampaignSearch(null);
        setCampaignNameSearch((_prev) => "");
        setCycleTypeSearch((_prev) => null);
        setVoteTitleSearch((_prev) => "");
        setTitleSearch((_prev) => "");
        setKeywordSearch('');
        setCategorySearch((_prev) => null);
    };

    const triggerRefresh = async (type: string = '') => {
        onCloseClick();
        setQuery({
            ...query,
            time_request: + new Date(),
        }, "push");
    }
    //End::Update

    const handleShowPrompt = (_prompt: string = '') => {
        setPromptShow((_prev) => _prompt);
        setIsShowPrompt((_prev) => true);
    }

    const handleSetNewsDetail = (detail: INews | null) => {
        setNewsDetail((_prev) => detail);
    }

    const onCloseClick = () => {
        handleSetNewsDetail(null);
    }

    // const scrollModalBodyToTop = () => {
    //     if (modalBodyInnerRef.current) {
    //         modalBodyInnerRef.current.scrollTo({ top: 0 });
    //     }
    //     if (modalSourceInnerRefs.current) {
    //         modalSourceInnerRefs.current.forEach((ref: any) => {
    //             if (ref) {
    //                 ref.scrollTo({ top: 0 });
    //             }
    //         });
    //     }
    // };

    const handlePreviousNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsPrevious = Number(index_news_current) - 1;
            const newsPrevious = listNews?.list[indexNewsPrevious];
            if (!!newsPrevious) {
                handleSetNewsDetail({
                    ...(newsPrevious),
                    index: indexNewsPrevious,
                    disabled_prev: false,
                    disabled_next: false
                });

            }
            if (!newsPrevious) {
                if (Number(query?.page) > 1) {
                    handleLoadPrev();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    const handleNextNews = (index_news_current: number = 0) => {
        if (listNews?.list?.length) {
            const indexNewsNext = Number(index_news_current) + 1;
            const newsNext = listNews?.list[indexNewsNext];
            if (!!newsNext) {
                handleSetNewsDetail({
                    ...(newsNext),
                    index: indexNewsNext,
                    disabled_prev: false,
                    disabled_next: false,
                });
            }
            if (!newsNext) {
                if (Number(query?.page) < Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))) {
                    handleLoadMore();
                } else {
                    toast(t('There is no news article anymore!'), CONFIG_OPTION_TOAST_INFO);
                }
            }
        }
    };

    // Column
    const columns = useMemo(
        () => [
            {
                Header: t('ID'),
                accessor: "id",
                filterable: true,
                sortable: true,
                thWidth: 90,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => (
                    <>
                        <div style={{ minWidth: '70px' }}>{cell?.value}</div>
                    </>
                ),
            },
            {
                Header: t('Keyword'),
                accessor: "keyword",
                filterable: true,
                sortable: false,
                thWidth: 160,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '140px' }} className="d-flex flex-wrap ">
                            {item?.keyword || '-'}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Category'),
                accessor: "categories",
                filterable: true,
                sortable: false,
                thWidth: 170,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '150px' }} className="d-flex flex-column flex-wrap ">
                            {(item?.source_vote_keyword?.categories || [])?.map((_c: any) => (
                                <div key={_c?.category_id}>{_c?.title} </div>
                            ))}
                            {(item?.source_vote_keyword?.categories || [])?.length === 0 && <>-</>}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Rank'),
                accessor: "rank",
                filterable: true,
                sortable: true,
                thWidth: 90,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '60px' }}>{item?.source_vote_keyword?.rank || '-'}</div>
                    )
                },
            },
            {
                Header: t('Vote Count'),
                accessor: "vote_count",
                filterable: true,
                sortable: true,
                thWidth: 120,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '100px' }}>{item?.source_vote_keyword?.total_votes || '-'}</div>
                    )
                },
            },
            {
                Header: t('Campaign'),
                accessor: "news_campaign",
                filterable: true,
                sortable: false,
                thWidth: 170,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    const _news_campaign = item?.news_campaign;
                    return (<>
                        <div style={{ minWidth: '150px' }} className="d-flex flex-wrap">
                            {_news_campaign?.campaign_name || '-'}
                        </div>
                    </>)
                },
            },
            // {
            //     Header: t('Boosting Keyword'),
            //     accessor: "keyword",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 160,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (<>
            //             <div style={{ minWidth: '140px' }} className="d-flex flex-wrap ">
            //                 {item?.keyword || '-'}
            //             </div>
            //         </>)
            //     },
            // },

            {
                Header: t('Vote Title'),
                accessor: "vote_title",
                filterable: true,
                sortable: false,
                thWidth: 250,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '200px', maxWidth: '400px' }} className="fs-15  d-flex align-items-center">
                            {item?.source_vote_keyword?.vote_title || '-'}
                        </div>
                    </>)
                },
            },
            // {
            //     Header: t('Image'),
            //     accessor: "images",
            //     thClass: 'text-center',
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 130,
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         return (
            //             <>
            //                 <div className="w-100 text-center" style={{ minWidth: '100px' }}>
            //                     <div style={{ width: '90px', height: '90px' }} className="m-auto cursor-pointer">
            //                         {item?.source_vote_keyword?.images?.[0] && <img src={item?.source_vote_keyword?.images?.[0]?.thumbnail_url || ''} className="flex-shrink-0 rounded w-100 h-100 object-fit-cover" alt={item?.keyword} />}
            //                     </div>
            //                 </div>
            //             </>
            //         )
            //     },
            // },
            {
                Header: t('News Title'),
                accessor: "title",
                filterable: true,
                sortable: false,
                thWidth: !listNews?.list?.length ? 100 : (window.innerWidth < 1650 ? 270 : 600),
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const item = cell?.row?.original;
                    return (<>
                        <div style={{ minWidth: '450px', maxWidth: '600px' }} className="fs-15  d-flex align-items-center" onClick={(e) => { e.preventDefault(); handleSetNewsDetail({ ...item, index: cell?.row?.index }) }}>
                            <div className="cursor-pointer hover-underline"><HighlightText text={item?.title || ''} keyword={item?.keyword || ''} opacity_bg={0.7} /></div>
                        </div>
                    </>)
                },
            },
            // {
            //     Header: t('Voting Target'),
            //     accessor: "cycle_type",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 140,
            //     thClass: 'text-center align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         const _source_voting = item?.source_voting;
            //         const _cycle_type = SCHEDULE_VOTE_OPTIONS_LANG?.find((_v: any) => (String(_source_voting?.cycle_type) === String(_v?.value)))?.label || '';
            //         return (<>
            //             <div style={{ minWidth: '90px' }} className="text-center">
            //                 <span>{_cycle_type || '-'}</span>
            //             </div>
            //         </>)
            //     },
            // },
            // {
            //     Header: t('Schedule'),
            //     accessor: "source_voting",
            //     filterable: true,
            //     sortable: false,
            //     thWidth: 200,
            //     thClass: 'text-start align-middle',
            //     Cell: (cell: any) => {
            //         const item = cell?.row?.original;
            //         const _source_voting = item?.source_voting;
            //         const _time = {
            //             schedule: SCHEDULE_OPTIONS_LANG?.find((_v: any) => (String(_source_voting?.schedule_type) === String(_v?.value)))?.label || '',
            //             date: String(_source_voting?.schedule_type) === ENUM_SCHEDULE.EVERY_DAY ? '' : (SCHEDULE_WEEKLY_OPTIONS_LANG?.find((_v: any) => (String(_source_voting?.schedule_day_of_week) === String(_v?.value)))?.label || ''),
            //             time: (`${String(_source_voting?.schedule_time || '')?.split(':')[0] || ''}:${String(_source_voting?.schedule_time || '')?.split(':')[1] || ''}`),
            //         };
            //         return (<>
            //             <div style={{ minWidth: '170px' }} className="d-flex flex-wrap gap-2">
            //                 {!!_source_voting?.schedule_time ?
            //                     (<div className='d-flex w-100'>
            //                         <span className="rounded-pill badge bg-success-subtle text-success fs-13">
            //                             {_time?.time}
            //                         </span>
            //                         {!!_time?.date ? <>
            //                             <span className="text-primary mx-1">~</span>
            //                             <span className="rounded-pill badge bg-primary-subtle text-primary fs-13">
            //                                 {_time?.date}
            //                             </span>
            //                         </> : <>
            //                             <span className="text-primary mx-1">~</span>
            //                             <span className="rounded-pill badge bg-primary-subtle text-primary fs-13">
            //                                 {_time?.schedule}
            //                             </span></>}
            //                     </div>) : <>-</>}
            //             </div>
            //         </>)
            //     },
            // },
            {
                Header: t('Date'),
                accessor: "date",
                filterable: true,
                sortable: false,
                thWidth: 120,
                thClass: 'text-start align-middle',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (<>
                        <div style={{ minWidth: '100px' }} className="d-flex flex-wrap">
                            {arrDate?.[0] || ''}
                        </div>
                    </>)
                },
            },
            {
                Header: t('Created At'),
                accessor: "created_at",
                filterable: true,
                sortable: true,
                thWidth: 130,
                thClass: 'align-middle text-end',
                Cell: (cell: any) => {
                    const arrDate = String(cell?.value || '').split(' ');
                    return (
                        <div className="text-end pe-3" style={{ minWidth: '120px' }}>
                            <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
                        </div>
                    )
                },
            },
            // {
            //     Header: t('Updated At'),
            //     accessor: "updated_at",
            //     filterable: true,
            //     sortable: true,
            //     thWidth: 120,
            //     thClass: 'align-middle text-end',
            //     Cell: (cell: any) => {
            //         const arrDate = String(cell?.value || '').split(' ');
            //         return (
            //             <div className="text-end pe-3" style={{ minWidth: '100px' }}>
            //                 <span><span>{arrDate?.[0] || '-'}</span> <br /> <span className="text-secondary">{arrDate?.[1] || '-'}</span> </span>
            //             </div>
            //         )
            //     },
            // },
            // {
            //     Header: t('Actions'),
            //     accessor: "__",
            //     thClass: 'align-middle text-center',
            //     thWidth: 120,
            //     sortable: false,
            //     Cell: (cell: any) => {
            //         const item: any = cell?.row?.original;
            //         return (
            //             <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0" style={{ minWidth: '90px' }}>
            //                 {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_UPDATE, userPermissions) && <TooltipCustom
            //                     title={t('Button Update Source')}
            //                     id={`update-us-${item?.id}`}
            //                 >
            //                     <li className=" list-inline-item me-0" id={`update-us-${item?.id}`}>
            //                         <Link className="btn btn-sm btn-soft-primary edit-item-btn" to="#"
            //                             onClick={(e) => { e.preventDefault(); handleSetAppDetail(item) }}
            //                         >
            //                             <i className="ri-pencil-fill align-bottom"></i>
            //                         </Link>
            //                     </li>
            //                 </TooltipCustom>}
            //                 {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_DELETE, userPermissions) && (
            //                     <TooltipCustom
            //                         title={t('Button Delete Source')}
            //                         id={`detail-cp-${item?.id}`}
            //                     >
            //                         <li className="list-inline-item" id={`detail-cp-${item?.id}`}>
            //                             <Link className="btn btn-sm btn-soft-danger edit-item-btn" to="#"
            //                                 onClick={(e) => { e.preventDefault(); handleConfirmDelete(item) }}
            //                             >
            //                                 <i className="ri-delete-bin-3-fill align-bottom"></i>
            //                             </Link>
            //                         </li>
            //                     </TooltipCustom>
            //                 )}
            //             </ul>
            //         );
            //     },
            // },
        ],
        [i18n?.language, idLoading, JSON.stringify(userPermissions), listNews?.list?.length]
    );

    const handleChangePage = useCallback((page: any) => {
        setQuery({ page: page + 1 })
    }, []);

    const handleChangeSorting = useCallback((sortBy: any) => {
        setQuery((_prev: any) => {
            return ({ ..._prev, ...sortBy });
        });
    }, []);

    const handleCallAllOption = async () => {
        try {
            const [res1]: any = await Promise.all([allCategoryVote()]);
            const _list_category_vote = (res1?.data || []);
            setCategoryVote((_prev: any) => _list_category_vote);

        } catch (error: any) {
            return error;
        }
    };

    useEffect(() => {
        handleCallAllOption();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.CAMPAIGN_VOTE_LIST, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-7">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    <span className="me-2">{t('Total')}:</span>
                                                    {(isListNewsLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                                        start={0}
                                                        end={listNews?.total || 0}
                                                        duration={1}
                                                        className="text-primary"
                                                    />)}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-0">

                                    {/* <LabelWrapper label={t('Campaign')} isShow={true}>
                                            <DropdownOption
                                                name="campaign"
                                                dataList={campaigns || []}
                                                placeholder={`${t("Campaign")}...`}
                                                className="dropdown-status-rounded z-hight"
                                                classNamePrefix="name-prefix"
                                                initialValue={campaignSearch || null}
                                                onChangeSelect={(e: any) => setCampaignSearch(e)}
                                                isHasOptionAll={true}
                                                optionAll={{ label: t('All'), value: '' }}
                                            />
                                        </LabelWrapper> */}

                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Keyword')}...`}
                                                value={keywordSearch}
                                                onChange={(e) => setKeywordSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Campaign')} isShow={!!campaignNameSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('Campaign')}...`}
                                                value={campaignNameSearch}
                                                onChange={(e) => setCampaignNameSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col>
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('Category')} isShow={true}>
                                            <DropdownCategoryVote
                                                name="dc_trend_category_id"
                                                placeholder={t('Category')}
                                                isClearable={false}
                                                dataList={categoryVote}
                                                initialValue={categorySearch}
                                                onChangeCategory={(event) => {
                                                    setCategorySearch(event);
                                                }}
                                                className="dropdown-status-rounded"
                                                classNamePrefix="name-prefix"
                                            />
                                        </LabelWrapper>
                                    </Col>

                                    {/* <Col sm={6} md={6} lg={6} xl={3} xxl={3} className='mt-3'>
                                        <LabelWrapper label={t('News Title')} isShow={!!titleSearch}>
                                            <Input
                                                type="text"
                                                className="form-control search"
                                                placeholder={`${t('News Title')}...`}
                                                value={titleSearch}
                                                onChange={(e) => setTitleSearch(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                        searchData();
                                                    }
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                    {/* <Col sm={6} md={6} lg={6} xl={6} xxl={3} className='date-picker-wrapper-custom mt-3 mt-xxl-2'>
                                        <LabelWrapper label={t('Date')} isShow={!!startDate || !!endDate}>
                                            <DatePickerCustom
                                                placeholder={`${t('Start Date')} - ${t('End Date')}`}
                                                startDate={startDate || null}
                                                endDate={endDate || null}
                                                onChangePicker={handleChangePicker}
                                                showOptions={[
                                                    'today', 'yesterday', 'two_day_ago',
                                                    'last_3_days', 'last_7_days', 'last_14_days', 'last_30_days',
                                                    'this_week', 'last_week',
                                                    'this_month', 'last_month',
                                                ]}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                    <Col sm={6} md={6} lg={6} xl={3} xxl={3} className="hstack gap-1 justify-content-center justify-content-sm-end  justify-content-xl-start mt-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2 "
                                                onClick={searchData}
                                                disabled={isListNewsLoading}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <CardBody className="pt-3">
                                <TableContainer
                                    className="custom-header-css"
                                    divClass="table-responsive table-card "
                                    tableClass="align-middle sticky-table-article-gold-price"
                                    theadClass="table-light"
                                    columns={columns}
                                    data={listNews?.list?.length ? listNews?.list : []}
                                    customPageSize={query.limit}
                                    customPageIndex={query.page - 1}
                                    totalRecords={listNews?.total}
                                    customPageCount={Math.ceil(Number(listNews?.total) / Number(query?.limit || 300))}
                                    handleChangePage={handleChangePage}
                                    manualSorting={true}
                                    sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                                    handleChangeSorting={handleChangeSorting}
                                    isLoading={isListNewsLoading}
                                    isShowPagination={true}
                                    isShowLoadingBottom={false}
                                    isScrollToTop={true}
                                />
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <ModalPreviewArticle
                isOpen={!!newsDetail}
                detail={newsDetail}
                isListNewsLoading={isListNewsLoading}
                type_page_no_param={query?.type_page_no_param}
                onClose={onCloseClick}
                triggerRefresh={triggerRefresh}
                handlePreviousNews={handlePreviousNews}
                handleNextNews={handleNextNews}
            />

            <Modal
                isOpen={!!isShowPrompt}
                centered={true}
                size="lg"
                scrollable={true}
                toggle={() => setIsShowPrompt(() => false)}
            >
                <ModalHeader toggle={() => setIsShowPrompt(() => false)}>
                    <>{t("Prompt")}</>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="fs-15" style={{ whiteSpace: 'break-spaces' }}>
                        {promptShow || ''}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center">
                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => setIsShowPrompt(() => false)}
                            style={{ width: '100px' }}
                        >
                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default ArticleList;